
import { MapLocation } from '@/types/location';

export const easternSchools: MapLocation[] = [
  // University Schools - Dhahran
  {
    id: 70061,
    name: "University Schools - Lower Elementary Male",
    type: "School",
    devices: 2,
    coordinates: [26.2994747, 50.1531564],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-9",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Lower Elementary (G1 to G3)",
      students: 423
    }
  },
  {
    id: 70062,
    name: "University Schools - Upper Elementary Male",
    type: "School",
    devices: 4,
    coordinates: [26.3000339, 50.1519622],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "9-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Upper Elementary (G4 to G6)",
      students: 390
    }
  },
  {
    id: 70063,
    name: "University Schools - Intermediate Male",
    type: "School",
    devices: 2,
    coordinates: [26.2995111, 50.1537324],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 387
    }
  },
  {
    id: 70064,
    name: "University Schools - Elementary Female",
    type: "School",
    devices: 1,
    coordinates: [26.299273, 50.153808],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 623
    }
  },
  {
    id: 70065,
    name: "University Schools - Intermediate Female",
    type: "School",
    devices: 2,
    coordinates: [26.299273, 50.153808],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 292
    }
  },
  {
    id: 70066,
    name: "University Schools - Secondary Female",
    type: "School",
    devices: 1,
    coordinates: [26.299273, 50.153808],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Secondary",
      students: 324
    }
  },
  // Ajyal International School - Dhahran
  {
    id: 70067,
    name: "Ajyal International School - Male",
    type: "School",
    devices: 2,
    coordinates: [26.2550424, 50.083577],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 444
    }
  },
  {
    id: 70068,
    name: "Ajyal International School - Female",
    type: "School",
    devices: 2,
    coordinates: [26.2550424, 50.083577],
    region: "Eastern",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 517
    }
  }
];
